export enum FilesLetters {
    'a' = 0,
    'b' = 1,
    'c' = 2,
    'd' = 3,
    'e' = 4,
    'f' = 5,
    'g' = 6,
    'h' = 7
}